import React from "react";
import Panel from "@/components/Panel";
import ProxyImage from "@/components/ProxyImage";

const videoCourseUrl = "https://cloud.video.taobao.com/play/u/null/p/1/e/6/t/1/444266483344.mp4";
const videoCourseImageUrl = "https://img.alicdn.com/imgextra/i2/54458674/O1CN01zSVuGB2DwkO6BVZXx_!!54458674.png";

interface VideoCourseCardProps {}

/**
 * 通用发货易视频教程卡片栏
 */
const VideoCourseCard: React.FC<VideoCourseCardProps> = React.memo(function (props) {
    // 如果是千牛端则仅显示来火定制功能
    if (import.meta.env.VITE_IS_QN) {
        return null;
    }

    return (
        <Panel title="视频教程" className="mb20">
            <div className="p15">
                <a href={videoCourseUrl} target="_blank">
                    <ProxyImage src={videoCourseImageUrl} className="w video-tutorials" alt="" />
                </a>
            </div>
        </Panel>
    );
});

export default VideoCourseCard;
